import { MenuItem, Select, Stack, Typography } from "@mui/material";

import { VERIFY_PRICE_SORT_OPTIONS } from "./verifyPriceUtils";

export default function VerifyPriceSortSelect({ value, onChange }) {
  const selectValue = VERIFY_PRICE_SORT_OPTIONS.some((option) => option.value === value)
    ? value
    : VERIFY_PRICE_SORT_OPTIONS[0].value;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography sx={{ fontSize: "0.8rem" }} component="label" htmlFor="verify-price-sort">
        Sort:
      </Typography>
      <Select
        id="verify-price-sort"
        size="small"
        value={selectValue}
        onChange={(event) => onChange(event.target.value)}
        aria-label="Sort verify price cards"
        sx={{ minWidth: 200 }}
      >
        {VERIFY_PRICE_SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
}
